import { eLopChuNhiemDefine } from "../../action-types/lop-chu-nhiem/ILopChuNhiemActionTypes";
import { generateActions } from "../generateActions";

export const lopChuNhiemActions = {
    ...generateActions(eLopChuNhiemDefine, "LOP_CHU_NHIEM"),
}